<template>
  <section class="members-data">
    <div class="mt-2 md:mt-3 lg:mt-1">
      <Table
        :data-source="tableFormatedData"
        :columns="columns"
        :loading="customEmailsQuery?.isFetching"
        :pagination="false"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'name'">
            <span v-if="record?.name" class="whitespace-nowrap w-full flex justify-center">{{
              record?.name
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'no_users'">
            <span v-if="record?.no_users" class="whitespace-nowrap w-full flex justify-center">{{
              record?.no_users
            }}</span>
            <span v-else class="w-full flex justify-center text-yellow-600">N/A</span>
          </template>
          <template v-if="column.key === 'locked'">
            <span class="whitespace-nowrap w-full flex justify-center">{{
              record?.locked ? 'Yes' : 'No'
            }}</span>
          </template>
          <template v-if="column.key === 'actions'">
            <span class="flex gap-0">
              <Button
                type="primary"
                size="small"
                title="View Campaign"
                class="btn-success rounded flex justify-center shadow m-auto items-center"
                @click="() => goTo(`/admin/mass-communications/campaign/${record.id}`)"
              >
                <PhFile weight="duotone" :size="16" /> View
              </Button>
              <Popconfirm
                title="Are you sure you want to delete this campaign?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="() => deleteCampaign(record)"
              >
                <Button
                  type="primary"
                  size="small"
                  title="Decline"
                  class="btn-error rounded flex justify-center shadow m-auto items-center"
                >
                  <PhTrash weight="duotone" :size="16" /> Delete
                </Button>
              </Popconfirm>
            </span>
          </template>
        </template>
      </Table>

      <div
        v-if="customEmailsQuery && customEmailsQuery.data"
        class="mt-6 flex items-center justify-center"
      >
        <Pagination
          :current="customEmailsQuery?.data?.current_page"
          :total="customEmailsQuery?.data?.total"
          show-less-items
          @change="handlePaginationChange"
          :page-size="10"
        />
      </div>
    </div>
  </section>
  <OldCampaignsQuery :page="page" :key="`${page}`" />
</template>
<script>
/* eslint-disable */
import campaignsApi from '@/services/apis/admin/campaigns.api';
import OldCampaignsQuery from '@/services/queries/admin/campaigns/OldCampaignsQuery.vue';
import { Button, message, Pagination, Popconfirm, Table } from 'ant-design-vue';
import { PhFile, PhTrash } from 'phosphor-vue';

export default {
  components: {
    Table,
    OldCampaignsQuery,
    Pagination,
    Button,
    PhFile,
    PhTrash,
    Popconfirm,
  },
  data() {
    return {
      columns: [
        { title: 'Campaign name', dataIndex: 'name', key: 'name' },
        { title: '# of users emails', dataIndex: 'no_users', key: 'no_users' },
        { title: 'Campaign locked', dataIndex: 'locked', key: 'locked' },
        { title: 'Actions', dataIndex: 'actions', key: 'actions' },
      ],
      tableData: [],
      page: 1,
    };
  },
  computed: {
    tableFormatedData() {
      const data = this?.customEmailsQuery?.data?.data?.map((d, ix) => ({
        no_users: d?.emails?.length || 0,
        name: d?.name,
        locked: d?.locked ?? false,
        id: d?._id,
        key: ix + 1,
      }));
      return data;
    },
    customEmailsQuery() {
      return this.$store.state.campaigns.oldCampaignsQuery;
    },
  },
  methods: {
    handlePaginationChange(page) {
      // , filters, sorter, data
      this.page = page;
    },
    goTo(url) {
      this.$router.push(url);
    },
    async deleteCampaign(record) {
      if (!record || !record.id) return;

      await campaignsApi.deleteCampaign({ id: record.id });
      this.customEmailsQuery?.refetch();
      message.success('Campaign deleted successfully');
    },
  },
};
</script>
